import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import MainServices from './MainServices'
import image1 from '../../../../assets/images/works-1.jpg';
import image2 from '../../../../assets/images/works-2.jpg';
import image3 from '../../../../assets/images/works-3.jpg';
import image4 from '../../../../assets/images/works-4.jpg';

import './style.css';

export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {selectedService: null};
  };

  onClick = serviceName => {
    this.setState( (prevState) => ({
      selectedService: serviceName === prevState.selectedService ? null : serviceName
    }));
  };

  render() {
    const { onClick } = this;
    return (
      <section className="flex w-100 flex-column z-998 relative">
        <Fade>
          <picture className={this.state.selectedService === "Brand Visual Design" ? "ghost-image-1 bg-black absolute" : "ghost-image-1-gone absolute"}>
                <img data-src={image1} src={image1} alt="third featured work"></img>
          </picture>
          <picture className={this.state.selectedService === "UI/UX Design" ? "ghost-image-2 bg-black absolute" : "ghost-image-2-gone absolute"}>
                <img data-src={image2} src={image2} alt="third featured work"></img>
          </picture>
          <picture className={this.state.selectedService === "Web Dev" ? "ghost-image-3 bg-black absolute" : "ghost-image-3-gone absolute"}>
                <img data-src={image3} src={image3} alt="third featured work"></img>
          </picture>
          <picture className={this.state.selectedService === "Mobile Apps Dev" ? "ghost-image-4 bg-black absolute" : "ghost-image-4-gone absolute"}>
                <img data-src={image4} src={image4} alt="third featured work"></img>
          </picture>
          <div className="capabilities-title w-100 tc">
            Capabilities
          </div>
          {[{title: "Brand Visual Design",description: "Creating the visual aspect of brand's identity"},
            {title: "UI/UX Design", description: "Designing meaningful pathways for users to user a product"},
            {title: "Web Dev", description: "Engineering, structuring, and deploying web service for businesses"},
            {title: "Mobile Apps Dev", description: "Enabling new experiences in the hands of mobile users"}].map( (item,index) =>
            <MainServices key={index} isSelected={this.state.selectedService === item.title} initialState={this.state.selectedService === null} onClick={onClick} serviceName={item.title} serviceDescription={item.description}/>
          )
          }
        </Fade>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Sections/Services/index.jsx